<!-- PCB -->
<template>
  <BaseFormItem
    class="custom_pcb_ban"
    :label="fields.label"
    labelTitle=" "
    :labelTips="fields.labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <BaseTipPopover 
          v-for="item in fields.options"
          :key="item.value" 
          :content="item.tips" 
          :disabled="!item.tips"
        >
          <el-radio-button
            slot="reference"
            class="insurance_type_radio"
            :label="item.value"
            :disabled="item.disabled"
          >
            {{ item.label }}
            <span v-if="item.desc" class="custom_pcb_ban__desc">
              {{ item.desc }}
            </span>
            <span v-if="item.value === 3" class="custom_pcb_ban__feeIcon">收费</span>
          </el-radio-button>
        </BaseTipPopover>
    </BaseRadioGroup>
    <!-- 上传、解析PCB文件 -->
    <div v-show="[1, 3].includes(val)" class="custom_pcb_ban__upload">
      <i :class="['custom_pcb_ban__list__linker', `linker_${val}`]"></i>
      <UploadAndAnalyzePcbafile 
        ref="UploadAndAnalyzePcbafileRef"
        v-model="pcbFile"
        :accept="accept"
        :type="`smt_${val}`"
        :pcbFileName="pcbFileName"
        @pcbaFileAnalyzeStatusChange="data => $emit('pcbaFileAnalyzeStatusChange', data || {})" 
        @change="(data) => handleFileChange(data)" 
        @analyzeSuccess="data => $emit('analyzeChange', data || {})" 
      />
    </div>
    <!-- PCB订单列表 -->
    <div v-if="val === 2" class="custom_pcb_ban__list">
      <i class="custom_pcb_ban__list__linker"></i>
      <PcbList :item="currentItem" @change="handleItemChange" />
    </div>
  </BaseFormItem>
</template>

<script>
import PcbList from '@@/components/pcbList/index'
import UploadAndAnalyzePcbafile from '@@/components/uploadAndAnalyzePcbafile/index'
import {  isMyCenterSite } from '@@/utils/is'
import { getSMTFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    },
    // PCB文件
    filePcb: {
      type: String,
      default: ''
    },
    // PCB文件名称
    pcbFileName: {
      type: String,
      default: ''
    },
  },
  components: {
    PcbList,
    UploadAndAnalyzePcbafile
  },
  data() {
    return {
      val: this.value,
      pcbFile: this.filePcb,
      currentItem: {},
      onceTips: true, // 自已提供上传提示，仅提示一次
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
    }
  },
  computed: {
    fields() {
      return getSMTFields('custom_pcb_ban')
    },
    accept() {
      return isMyCenterSite ? '*' : void 0
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
    item(item) {
      this.currentItem = item
    },
    filePcb(newVal) {
      this.pcbFile = newVal
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      // 切换到别的tab并且选择了华秋下单的时候清空上传分析组件数据
      if(val !== 2 && this.currentItem.order_id) {
        this.$refs.UploadAndAnalyzePcbafileRef.handleReset()
      } 
      this.$emit('input', val)
      this.$emit('change', val)
      this.isShowError(false)
    },
    handleEmitChange() {
      const { val, currentItem } = this
      this.$emit('change', val, val === 2 ? currentItem : {})
      this.isShowError(false)
    },
    handleItemChange(item) {
      this.currentItem = Object.assign({}, item)
      this.handleEmitChange()
    },
    handleFileChange(data = {}) {
      if (this.val == 3 && this.onceTips && data.val) {
        this.$confirm('为确保贴片的准确性，请再次确认上传的文件是否为PCB厂的最新生产文件', '温馨提示', {
          confirmButtonText: '是的',
          cancelButtonText: '不是，重新上传',
          lockScroll: false,
          center: true,
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          closeOnPressEscape: true
        }).then(() => {
          this.$emit('fileChange', data)
        }).catch(() => {
          this.$refs.UploadAndAnalyzePcbafileRef.handleReset()
        })
        this.onceTips = false
      } else {
        this.$emit('fileChange', data)
      }
      this.isShowError(false)
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';

.custom_pcb_ban {
  .custom_pcb_ban__desc {
    color: $--color-text-placeholder;
  }

  .custom_pcb_ban__upload {
    position: relative;
    margin-top: 5px;
    .custom_pcb_ban__list__linker {
      @include moduleLinkerMixin(15px, vertical, dark);
      position: absolute;
      top: -10px;
      left: 8px;
      &.linker_3 {
        left: 304px;
      }
    }
  }

  .custom_pcb_ban__list {
    position: relative;
    margin-top: 5px;
    .custom_pcb_ban__list__linker {
      @include moduleLinkerMixin(15px, vertical, dark);
      position: absolute;
      top: -10px;
      left: 104px;
    }
  }
  .custom_pcb_ban__feeIcon {
    position: absolute;
    right: 0;
    top: -10px;;
    width: 26px;
    height: 14px;
    font-size: 10px;
    line-height: 14px;
    color: #fff;
    text-align: center;
    background: #e6a23c;
    padding: 2px;
    border-radius: 0px 3px 0px 3px;
  }
}
</style>